// Tiny Slider hides slides from screen readers but leaves nested links focusable.
// Follow its actual visibility state, including clones and responsive updates.
export function initializeSliderAccessibility({container}) {
    const synchronize = slide => {
        slide.inert = slide.getAttribute('aria-hidden') === 'true';
    };

    Array.from(container.children).forEach(synchronize);
    const observer = new MutationObserver(records => {
        records.forEach(({target}) => {
            if (target.parentElement === container) synchronize(target);
        });
    });
    observer.observe(container, {
        attributes: true,
        attributeFilter: ['aria-hidden'],
        subtree: true,
    });
}
